module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@2x-94ddd0438cbf223b746e9ab0fc04f223.png";